import React from 'react';
import { withStyles } from 'tss-react/mui';
import { Container, Grid, Typography, IconButton } from '@mui/material';
import SolidBackdrop from './SolidBackdrop';
import MuiLink from '@mui/material/Link';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Link from './Link';
import theme from '../../MuiThemeProvider';
import { trackEvent, AnalyticsConstants } from '../../../utilities/analyticsUtilities';
import { getConfigurationProperty } from '../../../configuration';
import { withSsr } from '../../../withSsr';

const styles = theme => ({
    section: {
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            padding: `${theme.spacing(1)} ${theme.spacing(2)}`
        },
        [theme.breakpoints.up('md')]: {
            padding: `${theme.spacing(4)} 0`
        },
        marginTop: 0,
        marginBottom: 0,
    },
    link: {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        }
    }
});
class Footer extends React.Component {
	render() {
		const { classes, isSsr } = this.props;
        const supportLink = isSsr ? null : getConfigurationProperty("SupportEndpoint");

		return (
            <Container maxWidth='lg'>
                <Grid
                    container
                    alignItems='flex-start'
                    justifyContent='flex-start'
                    spacing={10}
                    className={classes.section}
                >
                    <SolidBackdrop
                        color={theme.palette.background.default}
                        border
                    />
                    <Grid
                        size={{ md: 4, xs: 12, sm: 6 }} 
                        item 
                    >
                        <Grid
                            container
                            alignItems='flex-start'
                            justifyContent='center'
                            spacing={4}
                            direction='column'
                        >
                            <Grid>
                                <Typography
                                    variant='h6'
                                    style={{textDecoration: 'underlined'}}
                                >
                                    Navigation
                                </Typography>
                            </Grid>
                            <Grid>
                                <Link
                                    to='/'
                                    color='textSecondary'
                                >
                                    Home
                                </Link>
                            </Grid>
                            <Grid>
                                <Link
                                    to='/pricing/'
                                    color='textSecondary'
                                >
                                    Pricing
                                </Link>
                            </Grid>
                            <Grid>
                                <Link
                                    to='/music-visualizer/'
                                    color='textSecondary'
                                >
                                    Music Visualizer
                                </Link>
                            </Grid>
                            <Grid>
                                <Link
                                    to='/lyric-video-maker/'
                                    color='textSecondary'
                                >
                                    Lyric Video Maker
                                </Link>
                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid 
                        item
                        size={{ md: 4, xs: 12, sm: 6 }}
                    >
                        <Grid
                            container
                            alignItems='flex-start'
                            justifyContent='center'
                            spacing={4}
                            direction='column'
                        >
                            <Grid>
                                <Typography
                                    variant='h6'
                                    style={{textDecoration: 'underlined'}}
                                >
                                    Company
                                </Typography>
                            </Grid>
                            <Grid>
                                <MuiLink
                                    className={classes.link}
                                    href='https://specterr.com/blog'
                                    color='textSecondary'
                                >
                                    Blog
                                </MuiLink>
                            </Grid>
                            <Grid>
                                <MuiLink
                                    href={supportLink}
                                    className={classes.link}
                                    color='textSecondary'
                                    target='_blank'
                                    onClick={() => {
                                        trackEvent('Clicked Footer Link', {
                                            name: 'Support',
                                            category: AnalyticsConstants.MISC_CATEGORY
                                        });
                                    }}
                                >
                                    Support
                                </MuiLink>
                            </Grid>
                            <Grid>
                                <MuiLink
                                    className={classes.link}
                                    href='https://specterr.getrewardful.com/signup'
                                    color='textSecondary'
                                    target='_blank'
                                    onClick={() => {
                                        trackEvent('Clicked Footer Link', {
                                            name: 'Affiliate Program',
                                            category: AnalyticsConstants.MISC_CATEGORY
                                        });
                                    }}
                                >
                                    Affiliate Program
                                </MuiLink>
                            </Grid>
                            <Grid>
                                <MuiLink
                                     className={classes.link}
                                    href='https://specterr.com/Specterr-Terms-of-Service.pdf'
                                    color='textSecondary'
                                    target='_blank'
                                    onClick={() => {
                                        trackEvent('Clicked Footer Link', {
                                            name: 'Terms of Service',
                                            category: AnalyticsConstants.MISC_CATEGORY
                                        });
                                    }}
                                >
                                    Terms of Service
                                </MuiLink>
                            </Grid>
                            <Grid>
                                <MuiLink
                                    className={classes.link}
                                    href='https://specterr.com/Specterr-Privacy-Policy.pdf'
                                    color='textSecondary'
                                    target='_blank'
                                    onClick={() => {
                                        trackEvent('Clicked Footer Link', {
                                            name: 'Privacy Policy',
                                            category: AnalyticsConstants.MISC_CATEGORY
                                        });
                                    }}
                                >
                                    Privacy Policy
                                </MuiLink>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid 
                        item
                        size={{ md: 4, xs: 12, sm: 6 }}
                    >
                        <Grid
                            container
                            alignItems='flex-start'
                            justifyContent='center'
                            spacing={4}
                            direction='column'
                        >
                            <Grid>
                                <Typography
                                    variant='h6'
                                    style={{textDecoration: 'underlined'}}
                                >
                                    Connect
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography
                                    variant='body2'
                                    color='textSecondary'
                                >
                                    Contact: info@specterr.com
                                </Typography>
                            </Grid>
                            <Grid>
                                <IconButton
                                    href='https://www.youtube.com/channel/UCRIe-r2RsY3BgjIq9T8rXDA'
                                    target='_blank'
                                    aria-label='Go to Specterr YouTube channel'
                                    onClick={() => {
                                        trackEvent('Clicked Social Link', {
                                            name: 'YouTube',
                                            category: AnalyticsConstants.MISC_CATEGORY
                                        });
                                    }}
                                    size="large">
                                    <YouTubeIcon />
                                </IconButton>
                                <IconButton
                                    href='https://www.instagram.com/specterrapp/'
                                    target='_blank'
                                    aria-label='Go to Specterr Instagram'
                                    onClick={() => {
                                        trackEvent('Clicked Social Link', {
                                            name: 'Instagram',
                                            category: AnalyticsConstants.MISC_CATEGORY
                                        });
                                    }}
                                    size="large">
                                    <InstagramIcon />
                                </IconButton>
                                <IconButton
                                    href='https://www.facebook.com/specterr/'
                                    target='_blank'
                                    aria-label='Go to Specterr Facebook'
                                    onClick={() => {
                                        trackEvent('Clicked Social Link', {
                                            name: 'Facebook',
                                            category: AnalyticsConstants.MISC_CATEGORY
                                        });
                                    }}
                                    size="large">
                                    <FacebookIcon />
                                </IconButton>
                                <IconButton
                                    href='https://x.com/specterrapp'
                                    target='_blank'
                                    aria-label='Go to Specterr X'
                                    onClick={() => {
                                        trackEvent('Clicked Social Link', {
                                            name: 'X',
                                            category: AnalyticsConstants.MISC_CATEGORY
                                        });
                                    }}
                                    size="large">
                                    <XIcon />
                                </IconButton>
                            </Grid>
                            <Grid>
                                <Typography
                                    variant='caption'
                                    color='textSecondary'
                                >
                                    © {new Date().getFullYear()} Tunebat LLC
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        );
	}
}

export default withSsr(withStyles(Footer, styles));